<!--
    CREATE TABLE `pos_posdevice` (
      `id` int(11) NOT NULL AUTO_INCREMENT,
      `device_model` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '版本名称',
      `device_id` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '设备号',
      `device_os` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '版本号',
      `sdk_version` varchar(20) COLLATE utf8mb4_bin DEFAULT NULL COMMENT 'SDK版本',
      `device_language` varchar(20) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '终端文字',
      `version_name` varchar(20) COLLATE utf8mb4_bin DEFAULT NULL COMMENT 'APP版本名称',
      `version_code` varchar(5) COLLATE utf8mb4_bin DEFAULT NULL COMMENT 'APP版本',
      `merch_id` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '商户号',
      `merch_name` varchar(100) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '商户名',
      `ter_id` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '终端号',
      `sign` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '签名',
      `trans_channel` varchar(20) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '交易渠道',
      `print_flag` varchar(20) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '打印标记',
      `para_add` varchar(20) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '其他',
      `usdk_version_code` varchar(20) COLLATE utf8mb4_bin DEFAULT NULL COMMENT 'USDK版本号',
      `group_name` varchar(100) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '组织',
      `group_url` varchar(255) COLLATE utf8mb4_bin DEFAULT NULL COMMENT 'url地址',
      `is_online` tinyint(1) DEFAULT '1' COMMENT '在线状态：0离线，1在线',
      `create_time` datetime DEFAULT NULL COMMENT '创建时间',
      `update_time` datetime DEFAULT NULL COMMENT '修改时间',
      PRIMARY KEY (`id`),
      KEY `device_id` (`device_id`),
      KEY `is_online` (`is_online`)
    ) ENGINE=InnoDB AUTO_INCREMENT=714 DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_bin;
    -->

<template>
  <div class="main-body">
    <!-- 查询区域 -->
    <div class="search-box">
      <el-input v-model="query.merch_name" placeholder="商户名" size="mini" style="width:200px" />
      <el-input v-model="query.device_id" placeholder="设备号" size="mini" style="width:200px" />
      <el-button type="primary" @click="getList" size="mini">搜索</el-button>
    </div>

    <!-- 表格 -->
    <el-table :data="pageData.list" border height="70vh">
      <el-table-column prop="id" label="ID" width="70" fixed />
      <el-table-column prop="group_name" label="组织" width="100" fixed />
      <el-table-column prop="merch_name" label="商户名" width="180" show-overflow-tooltip fixed />
      <el-table-column prop="merch_id" label="商户号" width="150" show-overflow-tooltip />
      <el-table-column prop="device_id" label="设备号" width="150" />
      <el-table-column prop="ter_id" label="终端号" width="100" />
      <el-table-column prop="is_online" label="在线状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_online===1" type="success">在线</el-tag>
          <el-tag v-else type="danger">离线</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="group_url" label="url地址" width="150" show-overflow-tooltip />
      <el-table-column prop="device_model" label="版本名称" width="120" />
      <el-table-column prop="device_os" label="版本号" width="90" />
      <el-table-column prop="sdk_version" label="SDK版本" width="90" />
      <el-table-column prop="device_language" label="终端文字" width="90" />
      <el-table-column prop="version_name" label="APP版本名称" width="100" />
      <el-table-column prop="version_code" label="APP版本" width="90" />
      <el-table-column prop="sign" label="签名" width="100" show-overflow-tooltip />
      <el-table-column prop="trans_channel" label="交易渠道" width="100" />
      <el-table-column prop="print_flag" label="打印标记" width="90" />
      <el-table-column prop="para_add" label="其他" width="100" />
      <el-table-column prop="usdk_version_code" label="USDK版本号" width="100" show-overflow-tooltip />
<!--      <el-table-column label="操作">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>-->
<!--          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="pageData.page"
      :page-size="pageData.size"
      layout="total, prev, pager, next,sizes"
      :total="pageData.total"
      :page-sizes="[10, 20, 50, 100]"
      style="margin-top:15px;text-align:right"
    />

    <!-- 新增/编辑弹窗 -->
    <!--    <el-dialog :visible.sync="dialogVisible" title="用户信息">-->
    <!--      <el-form :model="form" label-width="80px">-->
    <!--        <el-form-item label="用户名">-->
    <!--          <el-input v-model="form.username" />-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="手机号">-->
    <!--          <el-input v-model="form.phone" />-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--      <div slot="footer">-->
    <!--        <el-button @click="dialogVisible = false">取消</el-button>-->
    <!--        <el-button type="primary" @click="submit">确认</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'DeviceList',
  data() {
    return {
      query: {
        merch_name:"",
        device_id:"",
      },
      pageData:{
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // ====================== 获取列表 ======================
    getList() {
      const params = Params.ins()
        .where(this.query.merch_name ? ['company', 'like', '%' + this.query.merch_name + '%'] : null)
        .where(this.query.device_id ? ['company_code', '=', this.query.device_id] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('PosDevice/index', params, res => {
        if(res.code===200){
          this.pageData = res.data
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },
    sizeChange(size) {
      this.pageData.size = size
      this.getList()
    },

    // 新增
    handleAdd() {
      this.form = {}
      this.dialogVisible = true
    },

    // 编辑
    // async handleEdit(id) {
    //   const res = await api.detail(Params.ins().detail(id))
    //   if (res.code === 200) {
    //     this.form = res.data
    //     this.dialogVisible = true
    //   }
    // },
    //
    // // 提交保存
    // async submit() {
    //   const res = await api.save(Params.ins().save(this.form))
    //   if (res.code === 200) {
    //     this.$message.success('操作成功')
    //     this.dialogVisible = false
    //     this.getList()
    //   }
    // },
    //
    // // 删除
    // async handleDelete(id) {
    //   this.$confirm('确定删除？').then(async () => {
    //     const res = await api.delete(Params.ins().delete(id))
    //     if (res.code === 200) {
    //       this.$message.success('删除成功')
    //       this.getList()
    //     }
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body{
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/PosDevice/DeviceList.vue